import { Checkbox, Text } from "@ttc3k/trekker";
import { CheckCircle } from "iconoir-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { WhereaboutsModal } from "shared/components";
import { Flex } from "styled-system/jsx";
import { FormProvider, UseFormReturn } from "react-hook-form";
import { UpdateProfileFormValues } from "apps/directory/Operator/views";
import { FormEvent } from "react";

type ApproveOperatorModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onApproveOperatorClick: (
    isDisableModalSelected: boolean,
    isSavingAndApproving: boolean,
  ) => void;
  form: UseFormReturn<UpdateProfileFormValues>;
  formId: string;
  onSubmit: (e?: FormEvent) => Promise<void>;
};

export const ApproveOperatorModal = ({
  isOpen,
  onClose,
  onApproveOperatorClick,
  form,
  formId,
  onSubmit,
}: ApproveOperatorModalProps) => {
  const [disableModalInFuture, setDisableModalInFuture] = useState(false);
  const { t } = useTranslation();
  const isSavingAndApproving = form.formState.isDirty;
  return (
    <FormProvider {...form}>
      <form onSubmit={onSubmit} id={formId}>
        <WhereaboutsModal
          isOpen={isOpen}
          onClose={onClose}
          title={t(
            `directory:OPERATOR.SIDEBAR.APPROVE_MODAL.TITLE.${isSavingAndApproving ? "SAVE_AND_APPROVE" : "APPROVE"}`,
          )}
          HeaderIcon={CheckCircle}
          cancelButtonProps={{ onClick: onClose }}
          saveButtonCopy={t(
            `directory:OPERATOR.SIDEBAR.APPROVE_MODAL.SAVE_BUTTON_COPY.${isSavingAndApproving ? "SAVE_AND_APPROVE" : "APPROVE"}`,
          )}
          saveButtonProps={{
            form: "update-profile-form",
            type: isSavingAndApproving ? "submit" : "button",
            onClick: () =>
              onApproveOperatorClick(
                disableModalInFuture,
                isSavingAndApproving,
              ),
          }}
        >
          <Flex flexDir={"column"} gap={"400"}>
            <Text color={"text.mid"}>
              {t("directory:OPERATOR.SIDEBAR.APPROVE_MODAL.DESCRIPTION")}
            </Text>
            <Checkbox
              onCheckedChange={(d) => setDisableModalInFuture(!!d.checked)}
              checked={disableModalInFuture}
              checkboxFill={"white"}
              label={t(
                "directory:OPERATOR.SIDEBAR.APPROVE_MODAL.DISABLE_MODAL_LABEL",
              )}
            />
          </Flex>
        </WhereaboutsModal>
      </form>
    </FormProvider>
  );
};
